<template>
	<div>
		<ChooseFundingEmpty
			v-model="internalFinancesData"
			:input="internalPrioritiesData"
			:contest-id="contestId"
			:readonly="false"
			ref="funding"
		></ChooseFundingEmpty>

		<ChooseDACEmpty
      v-if="dacCodesEnabled"
			v-model="internalDacCodes"
			:contest-id="contestId"
			:readonly="false"
			type="PUBLIC_CONTEST"
			ref="chooseDac"
		></ChooseDACEmpty>
	</div>
</template>

<script>
import ChooseFundingEmpty from "@/view/landing_page/components/ChooseFundingEmpty";
import ChooseDACEmpty from "@/view/landing_page/components/ChooseDACEmpty";

export default {
  name: "ContestOfferStatsEmpty",

  components: {ChooseDACEmpty, ChooseFundingEmpty},

  data() {
    return {
      internalFinancesData: {},
      internalPrioritiesData: {},
      internalDacCodes: [],
    };
  },

  methods: {
    validateExistingRef(name) {
      if (this.$refs[name] === undefined) {
        return true;
      }
      if (typeof this.$refs[name]["validate"] !== "function") {
        return true;
      }
      return this.$refs[name].validate();
    },

    validate() {
      let valid = this.validateExistingRef("funding");
      valid &= this.validateExistingRef("chooseDac");
      return valid;
    }
  },

  watch: {
    financesData: {
      immediate: true,
      handler(value) {
        this.internalFinancesData = value;
      }
    },

    internalFinancesData: {
      immediate: true,
      handler(value) {
        this.$emit("update:financesData", value);
      }
    },

    prioritiesData: {
      immediate: true,
      handler(value) {
        this.internalPrioritiesData = value;
      }
    },

    internalPrioritiesData: {
      immediate: true,
      handler(value) {
        this.$emit("update:prioritiesData", value);
      }
    },


    dacCodes: {
      immediate: true,
      handler(value) {
        this.internalDacCodes = value;
      }
    },

    internalDacCodes: {
      immediate: true,
      handler(value) {
        this.$emit("update:dacCodes", value);
      }
    },
  },

  props: {
    readonly: {type: Boolean, required: true},
    contestId: {required: true},
    financesData: {type: Object, required: true},
    prioritiesData: {type: Object, required: true},
    dacCodesEnabled: {type: Boolean, default: true},
    dacCodes: {type: Array, required: true},
  }
};
</script>

<style scoped>

</style>